import React from 'react';
import { resolveProfilePhotoUrl } from '../lib/profilePhoto';

export default function UserAvatar({
  user,
  profilePhotoUrl,
  size = 52,
  fontSize,
  style,
  className,
}) {
  const initial = (user?.displayName || user?.email || 'U')[0].toUpperCase();
  const photoUrl = resolveProfilePhotoUrl({ profilePhotoUrl, photoURL: user?.photoURL });
  const fs = fontSize ?? Math.round(size * 0.46);

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: 999,
          objectFit: 'cover',
          flexShrink: 0,
          ...style,
        }}
      />
    );
  }

  return (
    <span
      className={className ? `iconwrap ${className}` : 'iconwrap'}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        // Flat ink, and it inverts on dark with the rest of the palette. The
        // gradient it replaces was the only lit surface in the chrome and the
        // only one that stayed dark-on-dark.
        background: 'var(--ink)',
        color: 'var(--bg)',
        fontWeight: 600,
        fontSize: fs,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      {initial}
    </span>
  );
}
